import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-generic-button',
  templateUrl: './generic-button.component.html',
  styleUrls: ['./generic-button.component.scss'],
})
export class GenericButtonComponent implements OnInit {

  @Input() size: 'normal' | 'small' = 'normal';
  @Input() iconUrl: string | undefined;
  @Input() iconName: string | undefined;
  @Input() iconFontSize = '24px';
  @Input() frontIcon = false;
  @Input() iconColor: string | undefined;
  @Input() text: string;
  @Input() textFontSize: string | undefined;
  @Input() disabled = false;
  @Input() expand = true;
  @Input() isNextButton = false;
  @Input() fill: 'solid' | 'outline' | 'clear' = 'solid';
  @Input() color: 'accent' | 'secondary' = 'accent';
  @Input() hasBoxShadow = true;

  @Output() clicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  get iconUrlForView(): string | undefined {
    if (this.iconUrl) { return this.iconUrl; }
    if (this.isNextButton) { return 'assets/icon/rebrand/arrow-forward.svg'; }
    return undefined;
  }
  get hasIcon(): boolean { return !!this.iconUrlForView || !!this.iconName; }
  get fontSize(): string {
    if (this.textFontSize) { return this.textFontSize; }
    return this.size === 'normal' ? '5vw' : '4vw';
  }

  constructor() { }

  ngOnInit() {}

  click(): void {
    this.clicked.next(true);
  }

}
